import React from "react";
import styled from "styled-components";
import gyeongwonLogo from "../../../../assets/images/gyunwonlogo.png";
import backgroundIntroductionModern from "../../../../assets/images/Background/Introduction_modern.png";
import backgroundDeliveryModern from "../../../../assets/images/Background/delivery_modern.png";
import backgroundGuideModern from "../../../../assets/images/Background/guide_modern.png";
import backgroundOpinionModern from "../../../../assets/images/Background/opinion_modern.png";
import backgroundPromotionalModern from "../../../../assets/images/Background/promotional_modern.png";

const MoleculeBackgroundModern = ({ contentsPurpose, title, content }) => {
  console.log(title);
  console.log(content);
  console.log(contentsPurpose);

  const backgroundImage = () => {
    console.log("contentsPurpose:", contentsPurpose);
    console.log("contentsPurpose type:", typeof contentsPurpose);

    if (!contentsPurpose || contentsPurpose === "") {
      return backgroundIntroductionModern; // 기본 이미지
    }

    // 문자열 정규화 후 매칭
    const normalizedPurpose = contentsPurpose.trim();

    if (normalizedPurpose.includes("정보전달형")) {
      return backgroundIntroductionModern;
    }
    if (normalizedPurpose.includes("프로그램 안내형")) {
      return backgroundDeliveryModern;
    }
    if (normalizedPurpose.includes("행사/대회 홍보형")) {
      return backgroundGuideModern;
    }
    if (normalizedPurpose.includes("의견수렴형")) {
      return backgroundOpinionModern;
    }
    if (normalizedPurpose.includes("창의활동/문화활동 소개형")) {
      return backgroundPromotionalModern;
    }

    // 기본 이미지 반환
    return backgroundIntroductionModern;
  };

  return (
    <StyledSlide16925>
      <StyledContainer>
        <StyledTitleArea>
          {title && <StyledTitle>{title}</StyledTitle>}
        </StyledTitleArea>
        <StyledContentArea>
          {content && (
            <StyledContentContainer>{content}</StyledContentContainer>
          )}
        </StyledContentArea>
        <StyledLogoArea>
          <StyledLogoImage src={gyeongwonLogo} alt="경원중학교 로고" />
        </StyledLogoArea>
      </StyledContainer>
      <StyledImageArea backgroundImage={backgroundImage()} />
    </StyledSlide16925>
  );
};

export default MoleculeBackgroundModern;

// Styled components for the new structure
const StyledMainDescription = styled.span`
  color: black;
  font-size: 32px;
  font-family: Pretendard;
  font-weight: 500;
  line-height: 48px;
  word-wrap: break-word;
  text-align: start;
`;

const StyledThickLine = styled.div`
  align-self: stretch;
  height: 0px;
  outline: 3px black solid;
  outline-offset: -2px;
`;

const StyledSectionTitle = styled.span`
  width: 144px;
  color: black;
  font-size: 32px;
  font-family: Pretendard;
  font-weight: 500;
  line-height: 48px;
  word-wrap: break-word;
  text-align: start;
`;

const StyledSectionContent = styled.span`
  color: black;
  width: 688px;
  font-size: 32px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 48px;
  word-wrap: break-word;
  text-align: start;
  align-items: left;
`;

const StyledThinLine = styled.div`
  align-self: stretch;
  height: 0px;
  outline: 1px black solid;
  outline-offset: 0px;
`;

const StyledSectionRow = styled.div`
  justify-content: flex-start;
  align-items: flex-start;
  gap: 32px;
  display: inline-flex;
  text-align: start;
`;

const StyledContentContainer = styled.div`
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  display: inline-flex;
`;

// Main container styled components
const StyledContainer = styled.div`
  position: absolute;
  left: 108px;
  top: 0;
  bottom: 0;
  right: 108px;
  padding-top: 192px;
  padding-bottom: 32px;
  display: flex;
  flex-direction: column;
`;

const StyledTitleArea = styled.div`
  width: 512px;
  flex-shrink: 0;
`;

const StyledTitle = styled.h1`
  margin: 0;
  padding: 0;
  font-family: Pretendard;
  font-size: 80px;
  line-height: 1.35;
  font-weight: 700;
  color: black;
  text-align: start;
  white-space: pre-line;
`;

const StyledContentArea = styled.div`
  width: 100%;
  height: 1152px;
  margin-top: auto;
  margin-bottom: 28px;
  flex-shrink: 0;
`;

const StyledImageArea = styled.div`
  width: 504px;
  height: 605px;
  left: 576px;
  top: 0px;
  position: absolute;
  background: ${(props) =>
    props.backgroundImage ? `url(${props.backgroundImage})` : "#D9D9D9"};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const StyledLogoArea = styled.div`
  width: 250px;
  height: 56px;
  flex-shrink: 0;
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledLogoImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

const StyledSlide16925 = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background: white;
  overflow: hidden;
`;

// Example usage component (you can use this structure for your content)
export const ContentExample = () => {
  return (
    <StyledContentContainer>
      <StyledMainDescription>
        미래 과학자를 꿈꾸는 여러분의 창의력과 탐구력을 마음껏 펼쳐보세요!
      </StyledMainDescription>
      <StyledThickLine />
      <StyledSectionRow>
        <StyledSectionTitle>대회 종목</StyledSectionTitle>
        <StyledSectionContent>
          - 대회종목
          <br />
          - 창의적인 아이디어와 과학적 근거를 바탕으로
          <br />
          &nbsp;&nbsp;논리적인 토론 진행
          <br />- 과학적 사고력과 발표 능력 향상
        </StyledSectionContent>
      </StyledSectionRow>
      <StyledThinLine />
    </StyledContentContainer>
  );
};
